<template>
    <div>

      <template v-for="(panel, index) in PANEL_ATTRIBUTES" :key="index">
      <span v-if="props.showNewFacets === panel.isNewFacet">
        <RefinementPanel  :attribute="panel.attribute"
                          :label="panel.label" :description="panel.description" />
      </span>
      </template>
    </div>
</template>

<script setup>

import { defineProps } from 'vue'
import RefinementPanel from './RefinementPanel.vue';
import { PANEL_ATTRIBUTES } from '@js/constants/panelAttributes';

const props = defineProps({
  categoryId: {
    type: Number,
    required: false,
    default: null
  },
  showNewFacets: {
    type: Boolean,
    required: false,
    default: false
  },
})

</script>
